import React, { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";

const SettingsContext = createContext(null);
export const useSettings = () => useContext(SettingsContext);

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(null);

  const load = async () => {
    try {
      const { data } = await api.get("/settings");
      setSettings(data);
    } catch {}
  };

  useEffect(() => { load(); }, []);

  return (
    <SettingsContext.Provider value={{ settings, reloadSettings: load }}>
      {children}
    </SettingsContext.Provider>
  );
}
